export const LANDING_WHATSAPP_PHONE = "16812992414";

export const LANDING_WHATSAPP_PREFILL = "Hola! Quiero mi nuevo look digital.";

export function landingWhatsAppHref() {
  return `https://wa.me/${LANDING_WHATSAPP_PHONE}?text=${encodeURIComponent(LANDING_WHATSAPP_PREFILL)}`;
}
